import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React, { useContext } from 'react'

import PageSection from 'components/common/PageSection'
import { EditGoldenSignalContext } from 'components/services/create/EditGoldenSignalContext'
import { TeamExternalIntegration } from 'types/api/services/golden-signal'
import { messageFromResponseError } from 'utils/strings'

export const SelectTeamExternalIntegration: React.FC<{
  disabled?: boolean
  integrationName: string
  removeSavedIntegrations?: boolean
  onChanged: (integration: TeamExternalIntegration) => void
}> = ({ integrationName, removeSavedIntegrations, onChanged, disabled }) => {
  const {
    externalIntegrationsError,
    hasExternalIntegrationsError,
    isExternalIntegrationsLoading,
    getAvailableExternalIntegrations,
    externalIntegrationType
  } = useContext(EditGoldenSignalContext)

  const availableExternalIntegrations = getAvailableExternalIntegrations(
    removeSavedIntegrations
  )

  return (
    <PageSection
      css={{ display: 'inherit', flexDirection: 'initial', flex: 'initial' }}
      errorMessage={messageFromResponseError(
        externalIntegrationsError,
        'There was an issue while retrieving team integrations'
      )}
      hasError={hasExternalIntegrationsError}
      isLoading={isExternalIntegrationsLoading}
    >
      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel
          data-test-service-select-team-external-integration-label
          id="select-team-external-integration-label"
        >
          Integration
        </InputLabel>
        <Select
          data-testid={`service-${externalIntegrationType
            .replace('_', '-')
            .toLowerCase()}-select-integration`}
          disabled={disabled}
          label="Integration"
          labelId="select-team-external-integration-label"
          value={integrationName || ''}
          onChange={(e) =>
            onChanged(
              availableExternalIntegrations.find(
                (eX) => eX.name === e.target.value
              )
            )
          }
        >
          {availableExternalIntegrations.map((exIt, index) => (
            <MenuItem
              key={index}
              data-testid={`service-${externalIntegrationType
                .replace('_', '-')
                .toLowerCase()}-select-integration-${exIt.name.toLowerCase()}`}
              value={exIt.name}
            >
              {exIt.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </PageSection>
  )
}
